module.exports = __webpack_public_path__ + "static/media/productImg2.b87c1e40.png";